import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportCompareKpiCharts } from '@api/kpi';

import { IExportKpiCompareDTO } from '@interfaces/kpi/dto/kpiDTO';

import { ESnackbarTypes } from '@enums/common';

import { EXPORT_COMPARE_CHARTS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportCompareKpiCharts = () => {
	const dispatch = useAppDispatch();

	const { mutate: exportCompareCharts } = useMutation<Array<IExportKpiCompareDTO>>({
		mutationKey: [EXPORT_COMPARE_CHARTS],
		mutationFn: (data: Array<IExportKpiCompareDTO>) => exportCompareKpiCharts(data),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportChartsSuccess,
				type: ESnackbarTypes.success,
			}));
		},
		onError: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportChartsError,
				type: ESnackbarTypes.error,
			}));
		},
	});

	return { exportCompareCharts };
};
